import { Component } from '@angular/core';
import { NavController, NavParams, ViewController } from 'ionic-angular';
import { ClubProvider } from '../../../providers/club/club';


@Component({
  selector: 'club-edit-form',
  templateUrl: 'club-edit-form.html'
})
export class ClubEditFormComponent {

  clubId:string = '';
  formValues:any = {
    name: '',
    description: '',
    avatar: ''
  }
  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public viewCtrl: ViewController,
    public clubProvider: ClubProvider) {
      this.clubId = this.navParams.get('clubId');
  }

  

  ngOnInit(){
    this.clubProvider.get(this.clubId).subscribe((res) => {
      if(res.success){
        this.formValues.name = res.data.name
        this.formValues.description = res.data.description
      }
    })
  }

  updateClub(){
    this.clubProvider.update(this.clubId, this.formValues).subscribe((res) => {
      if(res.success){
        this.viewCtrl.dismiss();
      }
    })
  }

  dismiss(){
    this.viewCtrl.dismiss();
  }

    // Convert image to base64
    handleFileSelect(evt){
      var files = evt.target.files;
      var file = files[0];
    
      if (files && file) {
          var reader = new FileReader();
  
          reader.onload =this._handleReaderLoaded.bind(this);
  
          reader.readAsBinaryString(file);
      }
    }
    _handleReaderLoaded(readerEvt) {
      var binaryString = readerEvt.target.result;
             this.compressImage("data:image/png;base64," + btoa(binaryString), 80, 80).then((res) => this.formValues.avatar = res);
     }
      // Compression
      compressImage(src, newX, newY) {
        return new Promise((res, rej) => {
          const img = new Image();
          img.src = src;
          img.onload = () => {
            const elem = document.createElement('canvas');
            elem.width = newX;
            elem.height = newY;
            const ctx = elem.getContext('2d');
            ctx.drawImage(img, 0, 0, newX, newY);
            const data = ctx.canvas.toDataURL();
            res(data);
          }
          img.onerror = error => rej(error);
        })
      }
      // End image conversion


}



// WEBPACK FOOTER //
// ./src/components/club-popover/club-edit-form/club-edit-form.ts